import React, { useEffect, useMemo, useState } from 'react';
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from '@mui/material';
import Grid from '@mui/material/Grid2';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import {
  RequiredText,
  Table,
 } from 'itaf';

export default function RegisterCanvas({data, menu, saveUser, setValidCanvas, isSaving }) {
  const [tableRef, setTableRef] = useState();

  const [products, setProducts] = useState([ ...menu ]);
  const [user, setUser] = useState({ ...data });
  const [visible, setVisible] = useState({
    currentPassword: false,
  });
  const [isLoading, setLoading] = useState(false);
  const validateRequired = (value) => !!value?.length;

  useEffect(() => {
    setUser({ ...data, password: data.id ? null : '' });
    setProducts([ ...menu ]);
  }, [data]);

  useEffect(() => {
    setProducts([ ...menu ]);
  }, [menu]);
    
  useEffect(() => {
    setLoading(true);
    if (data && products && products.length > 0 && data.items && tableRef) {
      var selected = {};
      data.items?.forEach((nivel1) => {
        const row1 = tableRef.getCoreRowModel().rows.find(
          (rowData) => (rowData.original.id === nivel1.id)
        );
        selected = { ...selected, [row1.id]: true };
        if (nivel1.items?.length > 0) {
          row1.subRows.map((row2) => {
            const nivel2 = nivel1.items.find((nivel2) => row2.original.id === nivel2.id);
            if (nivel2) {
              selected = { ...selected, [row2.id]: true };
              row2.subRows.map((row3) => {
                const idx3 = nivel2.items?.findIndex((nivel3) => row3.original.id === nivel3.id);
                selected = { ...selected, [row3.id]: idx3 > -1 };
              });
            } else {
              selected = { ...selected, [row2.id]: false};
            }
          });
        }
      });
      tableRef.setRowSelection(selected);
    }
    setLoading(false);
  }, [tableRef, data?.items]);

  useEffect(() => {
    setValidCanvas(validateRequired(user.name) &&
                    validateRequired(user.username) &&
                    validateRequired(user.email));
    if (user.id === 0) {
      setValidCanvas(validateRequired(user.password));
    }
  }, [user?.name, user?.username, user?.email, user?.password]);

  useEffect(() => {
    if (isSaving) {
      const rows = tableRef.getSelectedRowModel().rows;
      const prods = [];
      rows.map((nivel1) => {
        const items1 = [];
        if (nivel1.subRows?.length > 0) {
          nivel1.subRows.forEach((nivel2) => {
            const items2 = [];
            if (nivel2.subRows?.length > 0) {
              nivel2.subRows.forEach((nivel3) => {
                items2.push({ id: nivel3.original.itemId, name: nivel3.original.name });
              });
            }
            items1.push({ id: nivel2.original.itemId, name: nivel2.original.name, items: [ ...items2 ] });
          });
        }

        prods.push({ id: nivel1.original.id, name: nivel1.original.name, items: [ ...items1 ] });
      });

      const obj = { ...user, products: [ ...prods ], id: !user.id ? 0 : user.id };
      delete obj["items"];
      
      saveUser(obj);
    }
  }, [isSaving]);
  
  const handleMouseDownPassword = (event) => event.preventDefault();

  const handleClickShowCurrentPassword = () => 
    setVisible({ currentPassword: !visible.currentPassword});

  const onPasswordChange = (evt) =>
    setUser({ ...user, password: evt.target.value });
  
  const columns = useMemo(
    () => [
      {
        header: "Nome", accessorKey: "label", //minSize: '70', size: '80', maxSize: '100',
        enableHiding: false, enableColumnActions: false,
      },
    ],
    []
  );

  const buildTable = () => {
    return <Table
      title='Menu'
      columns={columns}
      data={products}
      setTableRef={setTableRef}
      isLoading={isLoading}
      enableBottomToolbar={false}
      enableColumnActions={false}
      enableColumnOrdering={false}
      enableExpandAll={true}
      enableHiding={false}
      enableRowSelection
      enableExpanding
      enablePagination={false}
      getSubRows={(originalRow) => originalRow.items}
    />;
  };

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <RequiredText
          name="username"
          label="Nome do usuário"
          field={user.username}
          msg="Nome do usuário deve ser preenchido"
          setValue={setUser}
        />
      </Grid>
      <Grid size={12}>
        <RequiredText
          name="name"
          label="Nome"
          field={user.name}
          msg="Nome deve ser preenchido"
          setValue={setUser}
        />
      </Grid>
      <Grid size={12}>
        <RequiredText
          name="email"
          label="E-mail"
          field={user.email}
          msg="E-mail deve ser preenchido"
          setValue={setUser}
        />
      </Grid>
      {user.password?.length > -1 &&
        <Grid size={12}>
          <FormControl sx={{ width: '100%' }} variant="outlined">
            <InputLabel required htmlFor="password">Senha</InputLabel>
            <OutlinedInput
              fullWidth
              required
              id="pass"
              name="pass"
              type={visible.currentPassword ? 'text' : 'password'}
              label="Senha"
              value={user.password || ''}
              onChange={onPasswordChange}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowCurrentPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {visible.currentPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </Grid>
      }
      {products?.length > 0 &&
        <Grid size={12} sx={(theme) => ({ mb: theme.spacing(2) })}>
          { buildTable() }
        </Grid>
      }
    </Grid>
  );
};
